import { EventEmitter } from 'events';
import { RESERVED_EVENTS } from './utils';

export default class extends EventEmitter {
    constructor() {
        super();
    }
    emit(ev, ...args) {
        if (RESERVED_EVENTS.hasOwnProperty(ev)) {
            throw new Error(`${ev} is a reserved event name`);
        }
        return super.emit(ev, ...args);
    }
    emitReserved(ev, ...args) {
        return super.emit(ev, ...args);
    }
}
